import { useState } from "react";
import { StrataPlanNumberValidationService } from "@stratify/shared";

interface UseStrataPlanValidationResult {
  strataPlanNumber: string;
  strataPlanError: string | null;
  setStrataPlanNumber: (value: string) => void;
  handleStrataPlanChange: (value: string) => void;
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
}

export const useStrataPlanValidation = (): UseStrataPlanValidationResult => {
  const [strataPlanNumber, setStrataPlanNumber] = useState("");
  const [strataPlanError, setStrataPlanError] = useState<string | null>(null);

  const strataPlanValidationService = new StrataPlanNumberValidationService();

  const handleStrataPlanChange = (value: string) => {
    setStrataPlanNumber(value);

    if (value) {
      const validation = strataPlanValidationService.validateStrataPlan(value);
      if (!validation.isValid) {
        setStrataPlanError("Invalid strata plan number format");
      } else {
        setStrataPlanError(null);
        setStrataPlanNumber(validation.formattedStrataPlanNumber || value);
      }
    } else {
      setStrataPlanError(null);
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    handleStrataPlanChange(e.target.value);
  };

  return {
    strataPlanNumber,
    strataPlanError,
    setStrataPlanNumber,
    handleStrataPlanChange,
    handleInputChange,
  };
};
